
import { BillFileUpload } from "./BillFileUpload";
import { BillDetailsForm } from "./BillDetailsForm";
import { Switch } from "@/components/ui/switch";

interface EnergyBillProps {
  title: string;
  emoji: string;
  emojiColor: string;
  type: 'gas' | 'electricity' | 'water';
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSelectChange: (value: string, name: string) => void;
  handleFileUpload: (file: File, type: 'gas' | 'electricity' | 'water') => Promise<string | undefined>;
  required?: boolean;
  uploadedFiles: {
    gas: string | null;
    electricity: string | null;
    water: string | null;
  };
  isDualTariff?: boolean;
  onDualTariffChange?: (pressed: boolean) => void;
}

export const EnergyBillSection = ({
  title,
  emoji,
  emojiColor,
  type,
  formData,
  handleInputChange,
  handleSelectChange,
  handleFileUpload,
  required = false,
  uploadedFiles,
  isDualTariff,
  onDualTariffChange,
}: EnergyBillProps) => {
  // Check if a file is uploaded for this utility type
  const isFileUploaded = uploadedFiles[type] !== null;

  return (
    <div className="border border-[#E5E7EB] rounded-lg p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-[#1F2937] flex items-center gap-2">
          <span style={{ color: emojiColor }}>{emoji}</span>
          {title} {required && <span className="text-red-500">*</span>}
        </h3>
        {type === 'electricity' && (
          <div className="flex items-center gap-2">
            <Switch
              checked={isDualTariff}
              onCheckedChange={onDualTariffChange}
              id="dual-tariff"
            />
            <span className="text-sm text-gray-600">Dual Tariff?</span>
          </div>
        )}
      </div>
      <BillFileUpload 
        type={type}
        handleFileUpload={handleFileUpload}
      />
      <div className="text-sm text-gray-500">or fill in the details below</div>
      <BillDetailsForm
        type={type}
        formData={formData}
        handleInputChange={handleInputChange}
        handleSelectChange={handleSelectChange}
        required={required && !isFileUploaded}
      />
    </div>
  );
};
